export default __webpack_public_path__ + "static/media/04.e0e819ad.jpg";